import { ZoneDistrictRefs } from './../../../../../constants';
import { isNullOrUndefined } from "../../../../../../../../tools";
import { IdProvider } from "../../../../../../../services/idprovider.service";
import { ServerCommunicatorService } from "../../../../../../../services/server-communicator.service";
import { UIUtils } from "../../../../../../../services/uiutils.service";
import { Utils } from "../../../../../../../services/utils.service";
import { DataContainer } from "../../../../../../infrastructure/datacontainer";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes, Roles } from "../../../../../../infrastructure/enums";
import { IPersistable } from "../../../../../../infrastructure/IPersistable";
import { PayloadPacketFacade } from "../../../../../../infrastructure/payloadpacket/payloadpacketfacade";
import { TransportData } from "../../../../../../infrastructure/transportdata";
import { ValidationResultAccumulator } from "../../../../../../infrastructure/validationresultaccumulator";
import { AshaEmployeeRecordFetchRequest } from "./ashaemployeerecordfetchrequest";
import { AshaEmployeeReportFilterFetchRequest } from './ashaemployeereportfilterfetchrequest';


export class AshaEmployeeRecordProps {

public created_date: string = '';
public updated_date: string = '';
public created_by: number = 0;
public updated_by: number = 0;
public id: number = 0;
public state_id: number = 0;
public readonly state_name: string = '';
public zone_id: number = 0;
public readonly zone_name: string = '';
public district_id: number = ZoneDistrictRefs.DistrictRef;
public district_name_en: string = '';
public district_name_mr: string = '';
public state_name_en: string = '';
public state_name_mr: string = '';
public asha_full_name: string = '';
public readonly af_full_name: string = '';
public block_id: number = 0;
public readonly block_name_en: string = '';
public readonly block_name_mr: string = '';
public phc_id: number = 0;
public readonly phc_name: string = '';
public sc_id: number = 0;
public readonly sc_name: string = '';
public village_id: number = 0;
public readonly village_name_en: string = '';
public readonly village_name_mr: string = '';
public role: number = Roles.Asha;
public personal_info_id: number = 0;
public population_covered_by_asha: number = 0;
public appoinment_date_from: string = '';
public appointment_date_to: string = '';
public under_supervision: number = 0;
public asha_post_number: number = 0;
public asha_post_id: number = 0;
public asha_post_name: string = '';
public af_post_id: number = 0;
public af_post_name: string = '';
public bcm_post_id: number = 0;
public bcm_post_name: string = '';
public readonly is_newly_created: boolean = false;

  private constructor(IsNewlyCreated: boolean) {
    this.is_newly_created = IsNewlyCreated;
  }

public static Blank() {
  return new AshaEmployeeRecordProps(true);
}
}

export class AshaEmployeeRecord implements IPersistable<AshaEmployeeRecord> {
  public static readonly mastertablename: string = 'asha_employee_record';

  private constructor(public readonly p: AshaEmployeeRecordProps, public readonly AllowEdit: boolean) {

  }

  public async EnsurePrimaryKeysWithValidValues(): Promise<void> {
    if (this.p.id === undefined || this.p.id === 0) {
      const newids = await IdProvider.GetInstance().GetNextEntityId();
      // const newids = await IdProvider.GetInstance().GetAllocateSingleIds();
      this.p.id = newids[0];
      if (this.p.id <= 0) throw new Error("Cannot assign Id. Please try again");
    }
  }

  public GetEditableVersion(): AshaEmployeeRecord {
    let newAshaEmployeeRecord: AshaEmployeeRecordProps = Utils.GetInstance().DeepCopy(this.p);
    return AshaEmployeeRecord.CreateInstance(newAshaEmployeeRecord, true);
  }

  public static CreateNewInstance() {
    return new AshaEmployeeRecord(AshaEmployeeRecordProps.Blank(), true);
  }

  public static CreateInstance(data: any, allowEdit: boolean) {
    return new AshaEmployeeRecord(data as AshaEmployeeRecordProps, allowEdit);
  }

  public CheckSaveValidity(_td: TransportData, vra: ValidationResultAccumulator): void {
    if (!this.AllowEdit) vra.add('', 'This object is not editable and hence cannot be saved.');
    if (this.p.state_id <= 0) {
      vra.add('state_id', 'State cannot be blank.');
    }
    if (this.p.zone_id <= 0) {
      vra.add('zone_id', 'Zone cannot be blank.');
    }
    if (this.p.district_id <= 0) {
      vra.add('district_id', 'District cannot be blank.');
    }
    if (this.p.block_id <= 0) {
      vra.add('block_id', 'Block cannot be blank.');
    }
    if (this.p.phc_id <= 0) {
      vra.add('phc_id', 'PHC cannot be blank.');
    }
    if (this.p.sc_id <= 0) {
      vra.add('sc_id', 'SC cannot be blank.');
    }
    if (this.p.under_supervision <= 0) {
      vra.add('under_supervision', 'Under Supervision cannot be blank.');
    }
    if (this.p.appoinment_date_from == '') {
      vra.add('appoinment_date_from', 'Appoinment Date cannot be blank.');
    }
  }

  public MergeIntoTransportData(td: TransportData) {
    DataContainerService.GetInstance().MergeIntoContainer(td.MainData, AshaEmployeeRecord.mastertablename, this.p);
  }

  private static m_currentInstance: AshaEmployeeRecord = AshaEmployeeRecord.CreateNewInstance();

  public static GetCurrentInstance() {
    return AshaEmployeeRecord.m_currentInstance;
  }

  public static SetCurrentInstance(value: AshaEmployeeRecord) {
    AshaEmployeeRecord.m_currentInstance = value;
  }

  // ********************************************
  public static cacheDataChangeLevel: number = -1;

  public static SingleInstanceFromTransportData(td: TransportData): AshaEmployeeRecord {
    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(td.MainData, AshaEmployeeRecord.mastertablename)) {
      for (let data of dcs.GetCollection(td.MainData, AshaEmployeeRecord.mastertablename)!.Entries) {
        return AshaEmployeeRecord.CreateInstance(data, false);
      }
    }

    return null as any;
  }

  public static ListFromDataContainer(cont: DataContainer,
    filterPredicate: (arg0: any) => boolean = null as any,
    sortPropertyName: string = "Name"): AshaEmployeeRecord[] {
    let result: AshaEmployeeRecord[] = [];

    let dcs = DataContainerService.GetInstance();

    if (dcs.CollectionExists(cont, AshaEmployeeRecord.mastertablename)) {
      let coll = dcs.GetCollection(cont, AshaEmployeeRecord.mastertablename)!;
      let entries = coll.Entries;

      if (!isNullOrUndefined(filterPredicate)) entries = entries.filter(filterPredicate);

      if (sortPropertyName.trim().length > 0) {
        entries = Utils.OrderByPropertyName(entries, sortPropertyName);
      }

      for (let data of entries) {
        result.push(AshaEmployeeRecord.CreateInstance(data, false));
      }
    }

    return result;
  }

  public static ListFromTransportData(td: TransportData): AshaEmployeeRecord[] {
    return AshaEmployeeRecord.ListFromDataContainer(td.MainData);
  }

  public static async FetchTransportData(req: AshaEmployeeRecordFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchTransportDataForReportFilter(req: AshaEmployeeReportFilterFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  // Function created For Trasaction Service filters 
  public static async FetchTransportDataForTransactionFilter(req: AshaEmployeeRecordFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchInstance(id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    req.asha_employee_record_ids.push(id);

    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.SingleInstanceFromTransportData(tdResponse);
  }

  public static async FetchInstances(ids: number[], errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    req.asha_employee_record_ids = ids;

    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.SingleInstanceFromTransportData(tdResponse);
  }

  public static async FetchList(req: AshaEmployeeRecordFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireList(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }
  // get all asha for report filter service file 
  public static async FetchEntireListForReportFilter(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeReportFilterFetchRequest();
    let tdResponse = await AshaEmployeeRecord.FetchTransportDataForReportFilter(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }


  // get all asha for Trasaction filter service file 
  public static async FetchEntireListForTransactionFilter(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    let tdResponse = await AshaEmployeeRecord.FetchTransportDataForTransactionFilter(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListByBFRef(under_supervision_ids: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    req.under_supervision_ids.push(under_supervision_ids)
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListByAFPostRef(af_post_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    req.af_post_ids.push(af_post_id)
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListByVillageRef(village_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    req.village_ids.push(village_id)
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListByAFandVillageRef(af_employee_record_id: number, village_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    if (af_employee_record_id) {
      req.af_employee_record_ids.push(af_employee_record_id)
    }
    if (village_id) {
      req.village_ids.push(village_id)
    }
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListByFilters(zone_id: number, district_id: number, block_id: number, bcm_post_id: number, phc_id: number, af_post_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new AshaEmployeeRecordFetchRequest();
    if (zone_id) {
      req.zone_ids.push(zone_id)
    }
    if (district_id) {
      req.district_ids.push(district_id)
    }
    if (block_id) {
      req.block_ids.push(block_id)
    }
    if (bcm_post_id) {
      req.bcm_post_ids.push(bcm_post_id)
    }
    if (phc_id) {
      req.phc_ids.push(phc_id)
    }
    if (af_post_id) {
      req.af_post_ids.push(af_post_id)
    }
    let tdResponse = await AshaEmployeeRecord.FetchTransportData(req, errorHandler) as TransportData;
    return AshaEmployeeRecord.ListFromTransportData(tdResponse);
  }

  // public static async FetchEntireListByCompanyRef(CompanyRef:number,errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
  //   let req = new CityFetchRequest();
  //   req.CompanyRefs.push(CompanyRef)
  //   let tdResponse = await City.FetchTransportData(req, errorHandler) as TransportData;
  //   return City.ListFromTransportData(tdResponse);
  // }

  public async DeleteInstance(): Promise<boolean> {
    let tdRequest = new TransportData();
    tdRequest.RequestType = RequestTypes.Deletion;

    this.MergeIntoTransportData(tdRequest);

    let pktRequest =
      PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService
      .GetInstance()
      .sendHttpRequest(pktRequest);

    if (!tr.Successful) {
      await UIUtils.GetInstance().GlobalUIErrorHandler(tr.Message);
      return false; // ❌ STOP
    }

    return true; // ✅ SUCCESS
  }


}
